<script setup>
import { computed } from 'vue';

import {
    formataMoedaReais,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const somaTotalItens = computed(() => {
    if (!props.solicitacao.dados || !props.solicitacao.dados.items) {
        return 0;
    }

    return props.solicitacao.dados.items.reduce((acc, item) => acc + item.quantidade * parseFloat(item.valor_unitario), 0).toFixed(2) || 0;
});
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="solicitacao.dados.local_entrega" :titulo="'Local de Entrega'"
        :conteudo="solicitacao.dados.local_entrega" />

    <LabelDados v-if="solicitacao.dados.justificativa" :titulo="'Justificativa'"
        :conteudo="solicitacao.dados.justificativa" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">

    <h3 class="text-900 font-bold text-sm mb-3 col-12">Itens Solicitados</h3>

    <div class="relative w-full" style="contain: inline-size;">
        <TabelaScrollContainer>
            <DataTable :value="solicitacao.dados.items" class="transition-linear transition-duration-100 w-full">
                <Column header="#" headerStyle="width:35px">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.index + 1" />
                    </template>
                </Column>

                <Column field="descricao" header="Descrição do Item" class="text-overflow-ellipsis"
                    style="min-width: 15rem;">
                    <template #body="slotProps">
                        <ColunaListas :descricao="slotProps.data.descricao" />
                    </template>
                </Column>

                <Column field="quantidade" class="text-right" style="min-width: 7rem; max-width: 7rem; width: 7rem;">
                    <template #header>
                        <span class="w-full text-right">Quantidade</span>
                    </template>

                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.data.quantidade" />
                    </template>
                </Column>

                <Column field="unidade_medida" class="text-right"
                    style="min-width: 10rem; max-width: 10rem; width: 10rem;">
                    <template #header>
                        <span class="w-full text-right">Unidade de Medida</span>
                    </template>
                    
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.data.unidade_medida" />
                    </template>
                </Column>

                <Column field="valor_unitario" class="text-right"
                    style="min-width: 8rem; max-width: 8rem; width: 8rem;">
                    <template #header>
                        <span class="w-full text-right">Valor Unitário</span>
                    </template>

                    <template #body="slotProps">
                        <ColunaListas :titulo="formataMoedaReais(slotProps.data.valor_unitario)" />
                    </template>
                </Column>

                <Column field="valor_total" class="text-right" style="min-width: 9rem; max-width: 9rem; width: 9rem;">
                    <template #header>
                        <span class="w-full text-right">Valor Total</span>
                    </template>

                    <template #body="slotProps">
                        <ColunaListas
                            :titulo="formataMoedaReais(slotProps.data.quantidade * slotProps.data.valor_unitario)" />
                    </template>

                    <template #footer>
                        <span class="text-sm text-900 font-semibold">
                            {{ formataMoedaReais(somaTotalItens) }}
                        </span>
                    </template>
                </Column>
            </DataTable>
        </TabelaScrollContainer>
    </div>
</template>